export default `/* Ids Line Chart Component */
/* Ids Axis Chart Component */
.chart-legend {
  display: flex;
  padding-inline-start: 8px;
  flex-direction: row;
  margin-top: -4px;
  justify-content: flex-start;
  width: inherit;
}
.chart-legend a {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  align-items: center;
  border: 1px solid transparent;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-chart-legend-font-size);
  color: var(--ids-chart-legend-color-text);
  padding-inline-start: 8px;
  padding-inline-end: 8px;
  padding-block-start: 2px;
  padding-block-end: 2px;
  text-decoration: none;
}
.chart-legend a:focus {
  outline: none;
  border-color: var(--ids-color-border-focus);
  box-shadow: var(--ids-shadow-focus);
}
.chart-legend .swatch {
  display: inline-flex;
  margin-inline-end: 8px;
  height: 12px;
  width: 12px;
  pointer-events: none;
}
.chart-legend .swatch.color-1 {
  background-color: var(--ids-chart-color-1);
}
.chart-legend .swatch.color-2 {
  background-color: var(--ids-chart-color-2);
}
.chart-legend .swatch.color-3 {
  background-color: var(--ids-chart-color-3);
}
.chart-legend .swatch.color-4 {
  background-color: var(--ids-chart-color-4);
}
.chart-legend .swatch.color-5 {
  background-color: var(--ids-chart-color-5);
}
.chart-legend .swatch.color-6 {
  background-color: var(--ids-chart-color-6);
}
.chart-legend .swatch.color-7 {
  background-color: var(--ids-chart-color-7);
}
.chart-legend .swatch.color-8 {
  background-color: var(--ids-chart-color-8);
}
.chart-legend .swatch.color-9 {
  background-color: var(--ids-chart-color-9);
}
.chart-legend .swatch.color-10 {
  background-color: var(--ids-chart-color-10);
}
.chart-legend .swatch.color-11 {
  background-color: var(--ids-chart-color-11);
}
.chart-legend .swatch.color-12 {
  background-color: var(--ids-chart-color-12);
}
.chart-legend .swatch.color-13 {
  background-color: var(--ids-chart-color-13);
}
.chart-legend .swatch.color-14 {
  background-color: var(--ids-chart-color-14);
}
.chart-legend .swatch.color-15 {
  background-color: var(--ids-chart-color-15);
}
.chart-legend .swatch.color-16 {
  background-color: var(--ids-chart-color-16);
}
.chart-legend .swatch.color-17 {
  background-color: var(--ids-chart-color-17);
}
.chart-legend .swatch.color-18 {
  background-color: var(--ids-chart-color-18);
}
.chart-legend .swatch.color-19 {
  background-color: var(--ids-chart-color-19);
}
.chart-legend .swatch.color-20 {
  background-color: var(--ids-chart-color-20);
}
.chart-legend .swatch.color-21 {
  background-color: var(--ids-chart-color-21);
}

.ids-chart-container {
  display: flex;
  flex-direction: column;
}
.ids-chart-container.legend-top {
  margin-block-end: 8px;
  flex-direction: column-reverse;
}
.ids-chart-container.legend-top .chart-legend {
  margin-inline-start: 0;
  justify-content: end;
}
.ids-chart-container.legend-right, .ids-chart-container.legend-left {
  flex-direction: row;
}
.ids-chart-container.legend-right .chart-legend, .ids-chart-container.legend-left .chart-legend {
  margin-inline-start: 0;
  flex-direction: column;
  justify-content: center;
}
.ids-chart-container.legend-right .chart-legend a, .ids-chart-container.legend-left .chart-legend a {
  margin-block-end: 8px;
  width: max-content;
}
.ids-chart-container.legend-left {
  flex-direction: row-reverse;
}

.ids-axis-chart {
  display: flex;
}
.ids-axis-chart.hidden {
  display: none;
}
.ids-axis-chart title {
  pointer-events: none;
}
.ids-axis-chart .grid {
  shape-rendering: crispedges;
  stroke: var(--ids-axis-chart-grid-color);
  stroke-width: 1;
  stroke-dasharray: 2 2;
}
.ids-axis-chart .grid.horizontal-lines line.is-minimum {
  stroke: var(--ids-axis-chart-zero-line-color-border);
  stroke-dasharray: none;
}
.ids-axis-chart .grid.hidden {
  stroke-width: 0;
}
.ids-axis-chart.horizontal .grid.horizontal-lines line:last-child {
  stroke: inherit;
  stroke-dasharray: inherit;
}
.ids-axis-chart.horizontal .grid.vertical-lines line.is-minimum {
  stroke: var(--ids-axis-chart-zero-line-color-border);
  stroke-dasharray: none;
}
.ids-axis-chart g[tabindex="0"]:focus {
  outline: var(--ids-axis-chart-outline-focus);
}
.ids-axis-chart .labels {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-axis-chart-font-family);
  font-size: var(--ids-axis-chart-font-size);
}
.ids-axis-chart .labels text {
  fill: var(--ids-axis-chart-color-text);
}
.ids-axis-chart .labels.x-labels {
  text-anchor: middle;
}
.ids-axis-chart .labels.y-labels {
  text-anchor: end;
}
.ids-axis-chart .labels.axis-labels text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: var(--ids-axis-chart-font-weight);
  text-anchor: middle;
}
.ids-axis-chart .audible {
  opacity: 0;
}

.ids-chart-container.selectable .audible {
  font-size: 1px;
}
.ids-chart-container.full-height {
  height: 100%;
  overflow-y: hidden;
}
.ids-chart-container.full-height svg {
  flex-grow: 1;
}
.ids-chart-container.full-width {
  width: 100%;
  overflow-x: hidden;
}
.ids-chart-container:not([class*=legend-]) .chart-legend, .ids-chart-container.legend-none .chart-legend {
  display: none;
}

ids-empty-message:not([hidden]),
::slotted(ids-empty-message:not([hidden])) {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
ids-empty-message:not([hidden])[hidden],
::slotted(ids-empty-message:not([hidden]))[hidden] {
  display: none;
}

.tooltip-center {
  margin-block: var(--ids-space-2xs);
  text-align: center;
}

.tooltip.chart-legend {
  flex-direction: column;
  margin-block-end: var(--ids-space-xs);
  padding: 0;
  white-space: normal;
}
.tooltip.chart-legend .swatch {
  margin-inline: var(--ids-space-2xs);
  padding: 0;
}

.tooltip-row span {
  padding-inline-start: var(--ids-space-3xs);
  padding-inline-end: var(--ids-space-2xs);
}

:host([dir=rtl]) .ids-axis-chart {
  transform: scale(-1, 1);
}
:host([dir=rtl]) .ids-axis-chart:not(.horizontal) .labels.y-labels text {
  transform: scale(-1, 1) translate(var(--ids-axis-chart-ylabels-x, -45px), 0);
}
:host([dir=rtl]) .labels.x-labels {
  transform: scale(-1, 1);
  transform-origin: unset;
}

.ids-axis-chart .bars .bar {
  outline: none;
}
.ids-axis-chart .bars rect.color-1:not([fill]) {
  fill: var(--ids-chart-color-1);
}
.ids-axis-chart .bars rect.color-2:not([fill]) {
  fill: var(--ids-chart-color-2);
}
.ids-axis-chart .bars rect.color-3:not([fill]) {
  fill: var(--ids-chart-color-3);
}
.ids-axis-chart .bars rect.color-4:not([fill]) {
  fill: var(--ids-chart-color-4);
}
.ids-axis-chart .bars rect.color-5:not([fill]) {
  fill: var(--ids-chart-color-5);
}
.ids-axis-chart .bars rect.color-6:not([fill]) {
  fill: var(--ids-chart-color-6);
}
.ids-axis-chart .bars rect.color-7:not([fill]) {
  fill: var(--ids-chart-color-7);
}
.ids-axis-chart .bars rect.color-8:not([fill]) {
  fill: var(--ids-chart-color-8);
}
.ids-axis-chart .bars rect.color-9:not([fill]) {
  fill: var(--ids-chart-color-9);
}
.ids-axis-chart .bars rect.color-10:not([fill]) {
  fill: var(--ids-chart-color-10);
}
.ids-axis-chart .bars rect.color-11:not([fill]) {
  fill: var(--ids-chart-color-11);
}
.ids-axis-chart .bars rect.color-12:not([fill]) {
  fill: var(--ids-chart-color-12);
}
.ids-axis-chart .bars rect.color-13:not([fill]) {
  fill: var(--ids-chart-color-13);
}
.ids-axis-chart .bars rect.color-14:not([fill]) {
  fill: var(--ids-chart-color-14);
}
.ids-axis-chart .bars rect.color-15:not([fill]) {
  fill: var(--ids-chart-color-15);
}
.ids-axis-chart .bars rect.color-16:not([fill]) {
  fill: var(--ids-chart-color-16);
}
.ids-axis-chart .bars rect.color-17:not([fill]) {
  fill: var(--ids-chart-color-17);
}
.ids-axis-chart .bars rect.color-18:not([fill]) {
  fill: var(--ids-chart-color-18);
}
.ids-axis-chart .bars rect.color-19:not([fill]) {
  fill: var(--ids-chart-color-19);
}
.ids-axis-chart .bars rect.color-20:not([fill]) {
  fill: var(--ids-chart-color-20);
}
.ids-axis-chart .bars rect.color-21:not([fill]) {
  fill: var(--ids-chart-color-21);
}

.ids-chart-container.selectable .ids-axis-chart .bars .bar {
  cursor: var(--ids-cursor-pointer);
}
.ids-chart-container.selectable .ids-axis-chart .bars .bar[selected] {
  opacity: 1;
}
.ids-chart-container.selectable .ids-axis-chart .bars .bar.not-selected {
  opacity: 0.5;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
